//#region src/constants.ts
var e = "demo-balance", t = {
	USD: 10,
	EUR: 10,
	GBP: 10,
	JPY: 1450,
	THB: 350
}, n = {
	USD: [
		1e3,
		5e3,
		1e4
	],
	EUR: [
		1e3,
		5e3,
		1e4
	],
	GBP: [
		1e3,
		5e3,
		1e4
	],
	JPY: [
		145e3,
		725e3,
		145e4
	],
	THB: [
		35e3,
		175e3,
		35e4
	]
};
//#endregion
export { t as n, n as r, e as t };
